/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductTypeDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    productTypeIdentifier: ProductTypeDto.productTypeIdentifier;
    nameDe: string;
    nameEn: string;
};
export namespace ProductTypeDto {
    export enum productTypeIdentifier {
        ORIGINAL = 'ORIGINAL',
        REBRAND = 'REBRAND',
        REBLEND = 'REBLEND',
        ALL = 'ALL',
    }
}

